import cls from "./formModal.module.scss"
import FormBuilderComponent from "../../FormBuilderComponent";
import React, {FC, LegacyRef, useEffect, useRef} from "react";
import {IFormComponentType} from "../../types";
import {CloseSvg} from "../../../../svg";
import {useDispatch} from "react-redux";
import {setFormElementValue, setFormPopupOpen} from "../../../../store/formbuilder";

interface IProps {
    title?: string;
    productInfo?: {
        sku: string,
        image: string;
        name: string
    };
    form: {
        formComponentInfo: IFormComponentType,
        customClassNames: string
    };
    recaptchaActive: string;
}

const FormModal: FC<IProps> = ({ form, recaptchaActive, title, productInfo }) => {
    const modalRef = useRef<Node>(null);
    const dispatch = useDispatch();
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (modalRef.current && !modalRef.current.contains(event.target as HTMLDivElement)) {
                dispatch(setFormPopupOpen({id: null, open: false}));
            }
        };
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [])
    useEffect(() => {
        if (productInfo?.sku) {
            const { formComponentInfo: {data: {form_builder_json = [], id: formId} = {} = {}} = {} } = form || {};
            let formBuilderArr = null;
            if (form_builder_json?.length > 0) {
                formBuilderArr = form_builder_json?.map((elem, index) => ({...elem, index}))
            }
            const hiddenSkuField = formBuilderArr?.find(elem => elem?.type === "hidden" && elem?.value.toLowerCase() === "sku")
            if (hiddenSkuField) {
                dispatch(setFormElementValue({
                    id: formId as number,
                    index: hiddenSkuField?.index,
                    fieldsForChange: {
                        forSku: true,
                        value: productInfo.sku
                    }
                }))
            }
        }
    }, []);
    return (
        <div className={cls.popup_pos}>
            <div className={`${cls.main_popup} ${title ? cls.main_popup_title : ""}`} ref={modalRef as LegacyRef<HTMLDivElement>}>
                {title ? (
                    <div className={cls.main_popup_header}>
                        <span>{title}</span>
                        <CloseSvg
                            style={{width: "20px", height: "20px", cursor: "pointer"}}
                            onClick={() => dispatch(setFormPopupOpen({id: null, open: false}))}
                        />
                    </div>
                ) : <CloseSvg
                    style={{float: "right", width: "20px", height: "20px", cursor: "pointer"}}
                    onClick={() => dispatch(setFormPopupOpen({id: null, open: false}))}
                />}
                {productInfo && productInfo?.image && productInfo?.name ? (
                    <div className={cls.main_popup_product_wrapper}>
                        <div className={cls.main_popup_img_wrapper} >
                            <img className={cls.main_popup_img} src={productInfo?.image} alt={`Product Image ${productInfo?.sku}`}/>
                            <h5>{productInfo?.name}</h5>
                        </div>
                    </div>
                ) : null}
                <FormBuilderComponent item={form as any} recaptchaActive={recaptchaActive}/>
            </div>
        </div>
    );
};

export default FormModal;
